import React, { useState, useEffect, useRef, useCallback } from 'react';
import jsPDF from "jspdf";
import "jspdf-autotable";
import axios from 'axios';
import { useLocation } from 'react-router-dom';

import { useNavigate } from 'react-router-dom';
import { Page, Text, View, Document, PDFDownloadLink, StyleSheet } from "@react-pdf/renderer";
import styles from "../../styles/SimpleStatementPage.module.css";

const SimpleStatementPage = () => {
  const [activeTab, setActiveTab] = useState('open');
  const [isInitialized, setIsInitialized] = useState(false); // Controlăm complet procesul de inițializare
    const [isTwoFactorEnabled, setIsTwoFactorEnabled] = useState(false);
      const location = useLocation(); // Inițializează useLocation
      const userRole = location.state?.role || 'client'; // Setează 'client' ca rol implicit
    const [twoFactorWarning, setTwoFactorWarning] = useState(false);
   const navigate = useNavigate();
    const [activeSection, setActiveSection] = useState("statement"); // Default la dashboard
    const openSection = (section) => {
      setTimeout(() => {
        setActiveSection(section);
      }, 1000);
    };
    const savedPermissions = JSON.parse(localStorage.getItem('permissions')) || [];
   const accessibleModules = savedPermissions && savedPermissions.length > 0 
      ? savedPermissions // ✅ Folosește permisiunile reale
      : userRole === 'client' 
        ? [
          'dashboard', 'accounting-manager', 'driver-pay', 'ifta', 
          'drivers', 'trucks', 'trailers', 'brokers', 'shippers', 
          'consignees', 'load-manager', 'load-finder', 'trucking', 
          'chat', 'settings', 'add-new-load'
        ] 
        : [];
    
      const queryParams = new URLSearchParams(window.location.search);
     
  
      useEffect(() => {
        if (activeTab === 'add-new-load') {
          setActiveSection('add-new-load');
        }
      }, [activeTab]);
    
      useEffect(() => {
        if (activeSection === 'settings' && !isTwoFactorEnabled) {
          const element = document.querySelector('.twoFactorWarningsettings');
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      }, [activeSection, isTwoFactorEnabled]);
  const handleLogout = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'https://api-backend.full-trucking-service.com/api';
  
      // Trimite cererea de logout către backend
      await axios.post(`${apiUrl}/logout`, {}, { withCredentials: true });
  
      // Șterge datele utilizatorului stocate local
      localStorage.removeItem('token');
      localStorage.removeItem('tokenExpiration');
      localStorage.removeItem('clientId');
      localStorage.removeItem('clientPackage');
      localStorage.removeItem('role');
  
      // Navighează utilizatorul înapoi la pagina de login
      navigate('/login');
    } catch (error) {
      console.error('Error during logout:', error);
      alert('An error occurred while logging out. Please try again.');
    }
  };

  return (
    <div className={styles.StatementPagecontainer}>
      {/* Header Menu */}
      <header className={styles.StatementPageheader}>
        <nav>
        <button
  className={`${styles.navStatementButton} ${activeSection === "statement" ? styles.activeTab : ""}`}
  onClick={() => openSection("statement")}
>
  Statement
</button>

<button
  className={`${styles.navStatementSettingsButton} ${activeSection === "settings" ? styles.activeTab : ""}`}
  onClick={() => openSection("settings")}
>
  Settings
</button>

        </nav>
        <li>
                   <button className={styles.buttonStatementPage} onClick={handleLogout}>Logout</button>
                 </li>
      </header>

      {/* Section: Statement */}
      {activeSection === "statement" && <Statement />}
      {activeSection === "settings" && <Settings />}
      </div>
  );
};

const Statement = () => {
  const [showDriverForm, setShowDriverForm] = useState(false);
  const [driver, setDriver] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    address: "",
    settlementType: "",
    fixedSalary: "",
    hourlyRate: "",
    hoursWorked: "",
    milesDriven: "",
    perMilePay: "",
    percentage: "",
    totalLoads: "",
    deductions: [],
    additions: [],
  });

  const settlementOptions = ["Fixed Salary", "Hourly Pay", "Miles Pay", "Percentage of Load", "Team Driver Pay"];

  const addDeduction = () => {
    setDriver({ ...driver, deductions: [...driver.deductions, { amount: "", reason: "" }] });
  };

  const addAddition = () => {
    setDriver({ ...driver, additions: [...driver.additions, { amount: "", reason: "" }] });
  };

  return (
    <div className={styles.statementSection}>
      <h2>Settlement</h2>
      <button className={styles.addDriverButtonStatement} onClick={() => setShowDriverForm(true)}>
  Add Driver
</button>


      {showDriverForm && (
        <div className={styles.driverStatementPageForm}>
          <label>First Name</label>
          <input type="text" value={driver.firstName} onChange={(e) => setDriver({ ...driver, firstName: e.target.value })} />

          <label>Last Name</label>
          <input type="text" value={driver.lastName} onChange={(e) => setDriver({ ...driver, lastName: e.target.value })} />

          <label>Phone</label>
          <input type="text" value={driver.phone} onChange={(e) => setDriver({ ...driver, phone: e.target.value })} />

          <label>Address</label>
          <input type="text" value={driver.address} onChange={(e) => setDriver({ ...driver, address: e.target.value })} />

          <label>Settlement Type</label>
          <select value={driver.settlementType} onChange={(e) => setDriver({ ...driver, settlementType: e.target.value })}>
            <option value="">Select Payment Type</option>
            {settlementOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          {/* Conditional Inputs */}
          {driver.settlementType === "Fixed Salary" && (
            <input type="number" placeholder="Fixed Salary" onChange={(e) => setDriver({ ...driver, fixedSalary: e.target.value })} />
          )}

          {driver.settlementType === "Hourly Pay" && (
            <>
              <input type="number" placeholder="Hours Worked" onChange={(e) => setDriver({ ...driver, hoursWorked: e.target.value })} />
              <input type="number" placeholder="Hourly Rate" onChange={(e) => setDriver({ ...driver, hourlyRate: e.target.value })} />
            </>
          )}

          {driver.settlementType === "Miles Pay" && (
            <>
              <input type="number" placeholder="Miles Driven" onChange={(e) => setDriver({ ...driver, milesDriven: e.target.value })} />
              <input type="number" placeholder="Per Mile Pay" onChange={(e) => setDriver({ ...driver, perMilePay: e.target.value })} />
            </>
          )}

          {driver.settlementType === "Percentage of Load" && (
            <>
              <input type="number" placeholder="Percentage" onChange={(e) => setDriver({ ...driver, percentage: e.target.value })} />
              <input type="number" placeholder="Total Loads" onChange={(e) => setDriver({ ...driver, totalLoads: e.target.value })} />
            </>
          )}
      <button className={styles.addDeductionButtonStatement} onClick={addDeduction}>
  Add Deduction
</button>

          {driver.deductions.map((d, index) => (
            <div key={index}>
              <input
                type="number"
                placeholder="Deduction Amount"
                onChange={(e) => {
                  const newDeductions = [...driver.deductions];
                  newDeductions[index].amount = e.target.value;
                  setDriver({ ...driver, deductions: newDeductions });
                }}
              />
              <input
                type="text"
                placeholder="Reason"
                onChange={(e) => {
                  const newDeductions = [...driver.deductions];
                  newDeductions[index].reason = e.target.value;
                  setDriver({ ...driver, deductions: newDeductions });
                }}
              />
            </div>
          ))}

<button className={styles.addAdditionButtonStatement} onClick={addAddition}>
  Add Addition
</button>

          {driver.additions.map((a, index) => (
            <div key={index}>
              <input
                type="number"
                placeholder="Addition Amount"
                onChange={(e) => {
                  const newAdditions = [...driver.additions];
                  newAdditions[index].amount = e.target.value;
                  setDriver({ ...driver, additions: newAdditions });
                }}
              />
              <input
                type="text"
                placeholder="Reason"
                onChange={(e) => {
                  const newAdditions = [...driver.additions];
                  newAdditions[index].reason = e.target.value;
                  setDriver({ ...driver, additions: newAdditions });
                }}
              />
            </div>
          ))}

<button className={styles.closeButtonStatement} onClick={() => setShowDriverForm(false)}>
  Close
</button>

        </div>
      )}

      <PDFDownloadLink document={<SettlementPDF driver={driver} />} fileName="settlement.pdf">
        <button className={styles.downloadStatementPageButton}>Download Settlement</button>
      </PDFDownloadLink>
    </div>
  );
};

const calculateTotalPay = (driver) => {
  let totalPay = 0;
  if (driver.settlementType === "Fixed Salary") {
    totalPay = parseFloat(driver.fixedSalary) || 0;
  } else if (driver.settlementType === "Hourly Pay") {
    totalPay = (driver.hoursWorked * driver.hourlyRate) || 0;
  } else if (driver.settlementType === "Miles Pay") {
    totalPay = (driver.milesDriven * driver.perMilePay) || 0;
  } else if (driver.settlementType === "Percentage of Load") {
    totalPay = ((driver.percentage / 100) * driver.totalLoads) || 0;
  }

  const totalDeductions = driver.deductions.reduce((sum, d) => sum + parseFloat(d.amount || 0), 0);
  const totalAdditions = driver.additions.reduce((sum, a) => sum + parseFloat(a.amount || 0), 0);
  return totalPay + totalAdditions - totalDeductions;
};

// ✅ Componenta PDF
const SettlementPDF = ({ driver }) => {
  const totalPay = calculateTotalPay(driver);

  return (
    <Document>
      <Page size="A4" style={pdfStyles.page}>
        
        {/* ✅ Antet */}
        <View style={pdfStyles.header}>
          <Text style={pdfStyles.title}>Settlement</Text>
        </View>

         {/* ✅ Secțiunea cu detalii șofer */}
         <View style={pdfStyles.section}>
          <Text style={pdfStyles.sectionTitle}>Driver Information</Text>
          <View style={pdfStyles.row}>
            <Text>{driver.firstName}</Text>
          </View>
          <View style={pdfStyles.row}>
            <Text>{driver.lastName}</Text>
          </View>
          <View style={pdfStyles.row}>
            <Text>{driver.phone}</Text>
          </View>
          <View style={pdfStyles.row}>
            <Text>{driver.address}</Text>
          </View>
        </View>

        {/* ✅ Tabel Metode de Plată */}
        <View style={pdfStyles.table}>
          <View style={pdfStyles.tableRow}>
            <Text style={pdfStyles.tableHeader}>Type</Text>
            <Text style={pdfStyles.tableHeader}>Quantity</Text>
            <Text style={pdfStyles.tableHeader}>Rate</Text>
            <Text style={pdfStyles.tableHeader}>Total</Text>
          </View>
          
          {driver.settlementType === "Fixed Salary" && (
            <View style={pdfStyles.tableRow}>
              <Text style={pdfStyles.tableCell}>Fixed Salary</Text>
              <Text style={pdfStyles.tableCell}>-</Text>
              <Text style={pdfStyles.tableCell}>${driver.fixedSalary}</Text>
              <Text style={pdfStyles.tableCell}>${driver.fixedSalary}</Text>
            </View>
          )}

          {driver.settlementType === "Hourly Pay" && (
            <View style={pdfStyles.tableRow}>
              <Text style={pdfStyles.tableCell}>Hourly Pay</Text>
              <Text style={pdfStyles.tableCell}>{driver.hoursWorked}h</Text>
              <Text style={pdfStyles.tableCell}>${driver.hourlyRate}/h</Text>
              <Text style={pdfStyles.tableCell}>${driver.hoursWorked * driver.hourlyRate}</Text>
            </View>
          )}

          {driver.settlementType === "Miles Pay" && (
            <View style={pdfStyles.tableRow}>
              <Text style={pdfStyles.tableCell}>Miles Pay</Text>
              <Text style={pdfStyles.tableCell}>{driver.milesDriven} miles</Text>
              <Text style={pdfStyles.tableCell}>${driver.perMilePay}/mile</Text>
              <Text style={pdfStyles.tableCell}>${driver.milesDriven * driver.perMilePay}</Text>
            </View>
          )}

          {driver.settlementType === "Percentage of Load" && (
            <View style={pdfStyles.tableRow}>
              <Text style={pdfStyles.tableCell}>Percentage of Load</Text>
              <Text style={pdfStyles.tableCell}>{driver.percentage}%</Text>
              <Text style={pdfStyles.tableCell}>${driver.totalLoads}</Text>
              <Text style={pdfStyles.tableCell}>${(driver.percentage / 100) * driver.totalLoads}</Text>
            </View>
          )}
        </View>

        {/* ✅ Deductions & Additions */}
        {driver.deductions.length > 0 && (
          <View style={pdfStyles.table}>
            <Text style={pdfStyles.sectionTitle}>Deductions</Text>
            <View style={pdfStyles.tableRow}>
              <Text style={pdfStyles.tableCell}>Reason</Text>
              <Text style={pdfStyles.tableCell}>Amount</Text>
            </View>
            {driver.deductions.map((d, index) => (
              <View key={index} style={pdfStyles.tableRow}>
                <Text style={pdfStyles.tableCell}>{d.reason}</Text>
                <Text style={pdfStyles.tableCell}>-${d.amount}</Text>
              </View>
            ))}
          </View>
        )}

        {driver.additions.length > 0 && (
          <View style={pdfStyles.table}>
            <Text style={pdfStyles.sectionTitle}>Additions</Text>
            <View style={pdfStyles.tableRow}>
              <Text style={pdfStyles.tableCell}>Reason</Text>
              <Text style={pdfStyles.tableCell}>Amount</Text>
            </View>
            {driver.additions.map((a, index) => (
              <View key={index} style={pdfStyles.tableRow}>
                <Text style={pdfStyles.tableCell}>{a.reason}</Text>
                <Text style={pdfStyles.tableCell}>+${a.amount}</Text>
              </View>
            ))}
          </View>
        )}

        {/* ✅ Grand Total – ALINIAT LA DREAPTA */}
        <View style={pdfStyles.footer}>
          <Text style={pdfStyles.totalLabel}>Grand Total:</Text>
          <Text style={pdfStyles.totalAmount}>${totalPay}</Text>
        </View>

      </Page>
    </Document>
  );
};

// ✅ Stiluri PDF – Mai compact și Grand Total la dreapta
const pdfStyles = StyleSheet.create({
  page: { padding: 15 },
  header: { textAlign: "center", marginBottom: 10 },
  title: { fontSize: 14, fontWeight: "bold", textAlign: "center" },

  section: { marginBottom: 8 },
  driverInfo: { fontSize: 10, marginBottom: 2 },

  table: { marginTop: 8, borderBottom: "1 solid black", paddingBottom: 5 },
  tableRow: { flexDirection: "row", justifyContent: "space-between", borderBottom: "1 solid black", paddingBottom: 3 },
  tableHeader: { flex: 1, fontWeight: "bold", fontSize: 9, textAlign: "center" },
  tableCell: { flex: 1, fontSize: 9, textAlign: "center" },

  footer: { marginTop: 12, flexDirection: "row", justifyContent: "flex-end" },
  totalLabel: { fontSize: 10, fontWeight: "bold", marginRight: 5 },
  totalAmount: { fontSize: 10, fontWeight: "bold", textAlign: "right" },
});

const Settings = ({ updateUserSettings, drivers = [], handleUpdateDriver }) => {
  const [updatedSettings, setUpdatedSettings] = useState({
    companyName: '',
    companyAddress: '',
    firstName: '',
    lastName: '',
    mcNumber: '',
    phone: '',
    fax: '',
    email: '',
    password: '',
    subscriptionType: '',
    contractStart: '',
    package: '',
    contractEnd: '',
    notes: ''
  });

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [selectedTrucks, setSelectedTrucks] = useState([]);
  const [selectedDrivers, setSelectedDrivers] = useState([]);
  const [trucks, setTrucks] = useState([]);
  const [driverEmail, setDriverEmail] = useState('');
  const [driverPassword, setDriverPassword] = useState('');
  const [subscriptionInfo, setSubscriptionInfo] = useState({
    paymentType: '',
    expirationDate: ''
  });

  const [isTwoFactorEnabled, setIsTwoFactorEnabled] = useState(false);
  const [twoFactorWarning, setTwoFactorWarning] = useState(false);
  

  

  const token = sessionStorage.getItem('token');
  const apiUrl = 'https://api-backend.full-trucking-service.com/api';
  const config = {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${apiUrl}/settings`, config);
      const settings = response.data;

      setUpdatedSettings({
        companyName: settings.companyName || '',
        companyAddress: settings.companyAddress || '',
        firstName: settings.firstName || '',
        lastName: settings.lastName || '',
        mcNumber: settings.mcNumber || '',
        phone: settings.phone || '',
        fax: settings.fax || '',
        email: settings.email || '',
        password: settings.password || '',
        subscriptionType: settings.subscriptionType || '',
        contractStart: settings.contractStart ? settings.contractStart.split('T')[0] : '',
        contractEnd: settings.contractEnd ? settings.contractEnd.split('T')[0] : '',
        package: settings.package || '',
        notes: settings.notes || ''
      });

      setSubscriptionInfo({
        subscriptionType: settings.subscriptionType || 'N/A',
        contractEnd: settings.contractEnd ? settings.contractEnd.split('T')[0] : 'N/A',
        package: settings.package || 'N/A',
      });

      setIsTwoFactorEnabled(settings.twoFactorAuthEnabled || false);
      setTwoFactorWarning(!settings.twoFactorAuthEnabled);
    } catch (error) {
      console.error('Failed to fetch settings:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdatedSettings({ ...updatedSettings, [name]: value });
  };
  const handleSaveSettings = async () => {
    if (password && password !== confirmPassword) {
        alert('Passwords do not match!');
        return;
    }

    // Validare format parolă
    const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@!#$%^&*])[A-Za-z\d@!#$%^&*]{12,}$/;
    if (password && !passwordRegex.test(password)) {
        alert('Password must be at least 12 characters long, contain an uppercase letter, a number, and a special character (@!#$%^&*).');
        return;
    }

    setIsSaving(true);

    try {
        const updatedData = { ...updatedSettings };
        // Include parola doar dacă este setată
        if (password) {
            updatedData.password = password;
        }

        await updateUserSettings(updatedData); // trimite doar datele relevante
        await fetchSettings();

        if (password) {
            alert('Password changed successfully. Please log in again.');
            sessionStorage.removeItem('token');
            window.location.href = '/login';
        } else {
            alert('Settings updated successfully');
        }
    } catch (error) {
        console.error('Error updating settings:', error);
        alert('Failed to update settings. Please try again.');
    } finally {
        setIsSaving(false);
    }
};


  const handleEnableTwoFactorAuth = () => {
    axios.post(`${apiUrl}/enable-two-factor`, { method: 'email' }, config)
      .then(() => {
        alert('Two-Factor Authentication via Email enabled. You will receive a code during login.');
        setIsTwoFactorEnabled(true);
        setTwoFactorWarning(false);
      })
      .catch(error => {
        console.error('Error enabling Two-Factor Authentication:', error);
        alert('Failed to enable Two-Factor Authentication.');
      });
  };

  const handleDisableTwoFactorAuth = () => {
    axios.post(`${apiUrl}/disable-two-factor`, {}, config)
      .then(() => {
        alert('Two-Factor Authentication has been disabled!');
        setIsTwoFactorEnabled(false);
        setTwoFactorWarning(true);
      })
      .catch(error => {
        console.error('Error disabling Two-Factor Authentication:', error);
        alert('Failed to disable Two-Factor Authentication.');
      });
  };

  useEffect(() => {
    fetchClientData();  
  }, []);

  const [clientData, setClientData] = useState({});

  const fetchClientData = async () => {
    try {
      const clientId = localStorage.getItem('clientId'); // ✅ Asigură-te că este corect
      if (!clientId) {
        console.error("⚠️ Client ID is missing in localStorage!");
        return;
      }
  
      console.log(`📡 Fetching client data for clientId: ${clientId}`); // ✅ Debugging
  
      const response = await axios.get(`${apiUrl}/clients/${clientId}`, config); // 🔥 Schimbăm endpoint-ul
      setClientData(response.data);
      
      console.log("✅ Client data received:", response.data); // ✅ Debugging
  
    } catch (error) {
      console.error('❌ Failed to fetch client data:', error);
    }
  };
  
  return (
    <div className={styles.settingsSimpleStatementPageSection}>
      {twoFactorWarning && (
        <div className={styles.twoFactorWarningsettingsSimpleStatementPage}>
          <p style={{ color: 'red' }}>Please set up Two-Factor Authentication to enhance your account security!</p>
        </div>
      )}

      <h2 className={styles.titlesettingsSimpleStatementPage}>Settings</h2>
      <form className={styles.settingsFormsettingsSimpleStatementPage}>
        <label>Company Name</label>
        <input
          name="companyName"
          value={updatedSettings.companyName || ''}
          onChange={handleChange}
          placeholder="Company Name"
          className={styles.inputFieldsettingsSimpleStatementPage}
        />

        <label>Company Address</label>
        <input
          name="companyAddress"
          value={updatedSettings.companyAddress || ''}
          onChange={handleChange}
          placeholder="Company Address"
          className={styles.inputFieldsettingsSimpleStatementPage}
        />

        <label>First Name</label>
        <input
          name="firstName"
          value={updatedSettings.firstName || ''}
          onChange={handleChange}
          placeholder="First Name"
          className={styles.inputFieldsettingsSimpleStatementPage}
        />

        <label>Last Name</label>
        <input
          name="lastName"
          value={updatedSettings.lastName || ''}
          onChange={handleChange}
          placeholder="Last Name"
          className={styles.inputFieldsettingsSimpleStatementPage}
        />

        <label>MC Number</label>
        <input
          name="mcNumber"
          value={updatedSettings.mcNumber || ''}
          onChange={handleChange}
          placeholder="MC Number"
          className={styles.inputFieldsettingsSimpleStatementPage}
        />

        <label>Phone Number</label>
        <input
          name="phone"
          value={updatedSettings.phone || ''}
          onChange={handleChange}
          placeholder="Phone Number"
          className={styles.inputFieldsettingsSimpleStatementPage}
        />

<label>Fax Number</label>
<input
  name="fax"
  value={updatedSettings.fax || ''}
  onChange={handleChange}
  placeholder="Fax Number"
  className={styles.inputFieldsettingsSimpleStatementPage}
/>

        <label>Email</label>
        <input
          name="email"  
          value={updatedSettings.email || ''}
          onChange={handleChange}
          placeholder="Email"
          className={styles.inputFieldsettingsSimpleStatementPage}
        />

        <label>New Password</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="New Password"
          className={styles.inputFieldsettingsSimpleStatementPage}
        />

        <label>Confirm Password</label>
        <input
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          placeholder="Confirm Password"
          className={styles.inputFieldsettingsSimpleStatementPage}
        />

        <button type="button" onClick={handleSaveSettings} className={styles.submitButtonClientsettingsSimpleStatementPage}>
          Save Settings
        </button>
      </form>
     
  
<h3 className={styles.subtitlesettingsSimpleStatementPage}>Subscription</h3>
<p className={styles.blackTextsettingsSimpleStatementPage}>Subscription Type: {subscriptionInfo.subscriptionType}</p>
<p className={styles.blackTextsettingsSimpleStatementPage}>Expiration Date: {subscriptionInfo.contractEnd}</p>
<p className={styles.blackTextsettingsSimpleStatementPage}>Package: {subscriptionInfo.package}</p>


      <h3 className={styles.subtitleTwoFactorsettingsSimpleStatementPage}>Two-Factor Authentication</h3>
      {isTwoFactorEnabled ? (
        <div>
          <p style={{ color: 'green' }}>Two-Factor Authentication is Enabled</p>
          <button onClick={handleDisableTwoFactorAuth} className={styles.deleteButtonTwoFactorsettingsSimpleStatementPage}>
            Disable 2FA
          </button>
        </div>
      ) : (
        <div>
          <button onClick={handleEnableTwoFactorAuth} className={styles.submitButtonTwoFactorsettingsSimpleStatementPage}>
            Enable 2FA via Email
          </button>
        </div>
      )}

<button onClick={() => window.location.href = '/FaqPage'} className={styles.actionButtonfaqsettingsSimpleStatementPage}>
  FAQ
</button>

    </div>
  );
};

export default SimpleStatementPage;
